export default __webpack_public_path__ + "static/media/404.29d73352.jpg";